import { View, Text, ViewStyle, Dimensions } from "react-native";
import React from "react";
import { TouchableOpacity } from "react-native-gesture-handler";
import { Sizing } from "../../../theme";

export interface ColorRectangleProps {
  color: string;
  disabled?: boolean;
  selected?: boolean;
  onPress?: () => void;
  style?: ViewStyle;
  children?: React.ReactNode;
}

export function ColorRectangle({
  color,
  disabled,
  selected,
  onPress,
  style,
  children,
}: ColorRectangleProps) {
  return (
    <TouchableOpacity
      disabled={disabled}
      onPress={onPress}
      style={[
        {
          margin: 3,
          minWidth: Sizing.cs(40),
          minHeight: Sizing.cs(40),
          paddingHorizontal: 10,
          borderRadius: 10,
          backgroundColor: selected ? "transparent" : color,
          borderWidth: selected ? 5 : 0,
          borderColor: color,
          alignItems: "center",
          justifyContent: "center",
          alignSelf: "flex-start", // wichtig, damit kein unnötiges Strecken entsteht
        },
        style,
      ]}
    >
      {typeof children === "string" ? (
        <Text numberOfLines={1} ellipsizeMode="tail">
          {children}
        </Text>
      ) : (
        children
      )}
    </TouchableOpacity>
  );
}
